import { render } from "./BlogPage.vue?vue&type=template&id=210b2c4c&scoped=true"
import script from "./BlogPage.vue?vue&type=script&lang=js"
export * from "./BlogPage.vue?vue&type=script&lang=js"

import "./BlogPage.vue?vue&type=style&index=0&id=210b2c4c&scoped=true&lang=css"
import "./BlogPage.vue?vue&type=style&index=1&id=210b2c4c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-210b2c4c"]])

export default __exports__